<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Excel Temp List</b-navbar-brand>
          <div>
            <h5 class="text-muted justify-content-center">
              <small>{{ totalRows }} Entries</small>
            </h5>
          </div>
        </b-navbar>
        <b-row>
          <b-col md="9">
            <label>Common</label>

            <b-form-group>
              <b-input-group>
                <b-form-input
                  :formatter="capitalizeAll"
                  v-model="commonFilter"
                  @input="debounceSearch"
                  placeholder="Type To Search"
                />
                <b-input-group-append>
                  <b-button
                    @click="
                      commonFilter = '';
                      ClearFilter();
                    "
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group></b-col
          >
        </b-row>
        <b-card class="formCard">
          <b-card-text>
            <div class="mt-3">
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="All_ExcellTempList"
                  responsive
                  :fields="Columns"
                  primary-key="et_id"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  class="position-relative"
                >
                  <template slot="et_id" slot-scope="row0">
                    <span>
                      {{ row0.index + 1 + (currentPage - 1) * perPage }}
                    </span>
                  </template>
                  <template slot="clientName" slot-scope="row1">
                    <span>{{ row1.item.clientName }}</span>
                  </template>
                  <template slot="activeStatus" slot-scope="row2">
                    <b-badge
                      :variant="row2.item.et_is_active == '1' ? 'success' : 'danger'"
                      >{{ row2.item.activeStatus }}</b-badge
                    ><br />
                    <b-badge
                      :variant="row2.item.et_is_delete == '0' ? 'success' : 'danger'"
                      >{{ row2.item.deleteStatus }}</b-badge
                    >
                  </template>
                  <template slot="created_at" slot-scope="row3">
                    <span v-if="row3.item.createdBy">{{
                      "Created By : " + row3.item.createdBy
                    }}</span
                    ><br />
                    <span v-if="row3.item.created_at">{{
                      "Created Date : " + row3.item.created_at
                    }}</span
                    ><br />
                    <span v-if="row3.item.updatedBy">{{
                      "Updated By : " + row3.item.updatedBy
                    }}</span
                    ><br />
                    <span v-if="row3.item.updated_at">{{
                      "Updated Date : " + row3.item.updated_at
                    }}</span>
                  </template>
                  <template slot="DSRIMPExcelTemp" slot-scope="row4">
                    <b-button
                      style="margin-left: 2px; margin-bottom: 2px; font-size: 0.675rem"
                      size="sm"
                      v-if="
                        row4.item.excel_template_json != '' &&
                        row4.item.excel_template_json != null &&
                        row4.item.excel_template_json != undefined
                      "
                      @click="
                        getTemplateDet(
                          row4.item.excel_template_json,
                          'Export',
                          row4.item.clientName + ' - Export DSR Template'
                        )
                      "
                      variant="success"
                      >Export DSR Template</b-button
                    >
                    <b-button
                      style="margin-left: 2px; margin-bottom: 2px; font-size: 0.675rem"
                      size="sm"
                      v-if="
                        row4.item.DSRIMPExcelTemp != '' &&
                        row4.item.DSRIMPExcelTemp != null &&
                        row4.item.DSRIMPExcelTemp != undefined
                      "
                      @click="
                        getTemplateDet(
                          row4.item.DSRIMPExcelTemp,
                          'Import',
                          row4.item.clientName + ' - Import DSR Template'
                        )
                      "
                      variant="success"
                      >Import DSR Template</b-button
                    >
                    <b-button
                      style="font-size: 0.675rem"
                      size="sm"
                      variant="primary"
                      @click="goToDrag(row4.item)"
                      >Clients Excel Temp</b-button
                    >
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="5"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="ExcellTempList-modal"
      hide-footer
      :title="'All ' + excellDetails.title"
    >
      {{ excellDetails[excellDetails.viewType] }}
      <b-table
        show-empty
        stacked="md"
        :items="TemplateDataList"
        :fields="TemplateField"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
      </b-table>

      <b-row class="mt-2">
        <b-col class="text-center">
          <b-button variant="outline-danger" @click="hideTemplateDet">Close</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/excellTemp");
      if (globalPermissionStatus("DSR Reports")) {
        this.getAllExcellTempList();
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export As Excel",
      addEditCard: false,
      isLoading: false,
      selectDateFormat,
      TemplateField: [],
      TemplateDataList: [],
      Columns: [
        {
          key: "et_id",
          label: "SN",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "activeStatus",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "created_at",
          label: "Others",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "DSRIMPExcelTemp",
          label: "Action",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      docURL: URL_BASE_DOC,
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      sortBy: null,
      sortDesc: false,
      pageOptions: [5, 10, 15],
      adminToggle: this.$sessionsStorage.get(),
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      All_ExcellTempList: [],
      validate: true,
      visible: false,
      excellDetails: {
        type: "",
        viewType: "",
        title: "",
      },
      commonFilter: "",
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
  },
  methods: {
    goToDrag(items) {
      console.log("1");
      this.$sessionsStorage.set("editClientId", "");
      this.$sessionsStorage.set("editClientName", "");
      this.$sessionsStorage.set("editClientExcelTemplate", "");
      this.$sessionsStorage.set("editClientId", items.clientId);
      this.$sessionsStorage.set("editClientName", items.clientName);
      this.$sessionsStorage.set("editClientExcelTemplate", items.excel_template_json);

      this.$router.push({
        path: "/drag_drop",
      });
    },
    ClearFilter() {
      this.commonFilter = "";
      this.getAllExcellTempList();
    },
    getAllExcellTempList() {
      console.log("2");
      this.All_ExcellTempList = [];
      this.totalRows = 0;
      this.isLoading = true;
      let payload = {
        itemCode: "getExcellTemplate",
        ClientId: "",
        commonFilter: this.commonFilter,
      };
      console.log("PS Payload => ", payload);
      CommonService.getCheckBLDetails(payload)
        .then((response) => {
          console.log("PS response => ", response);
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.CLResult.length > 0) {
              this.All_ExcellTempList = data.CLResult;
              this.totalRows = data.CLResult.length;
            }
            console.log(" All_ExcellTempList response=>", data);
          } else {
            this.All_ExcellTempList = [];
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_ExcellTempList Error: ", error);
        });
    },
    goBack() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllExcellTempList();
      }, 1000);
    },
    setFocus: function () {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    getTemplateDet(item, type, title) {
      console.log("3");
     // this.isLoading = true;
      this.excellDetails.type = type;
      this.excellDetails.viewType = type;
      this.excellDetails.title = title;
      this.TemplateField = JSON.parse(item);
      this.$refs["ExcellTempList-modal"].show();
    },
    hideTemplateDet() {
      this.$refs["ExcellTempList-modal"].hide();
      // this.isLoading = false;
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// excellTemp.vue?2efded11